import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatEnumValue(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase())
}

/**
 * Detects if the app is running in a Lovable Preview environment.
 * Preview environments have sandbox restrictions that block some cross-origin navigations
 * (e.g., Outlook refuses to load when opened from a sandboxed iframe).
 */
export function isLovablePreview(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname.includes('lovableproject.com') ||
    hostname.includes('id-preview--') ||
    hostname.endsWith('.lovable.app') && hostname.includes('preview')
  );
}
